import { createFileRoute } from '@tanstack/react-router';

import { PurchaseOrdersPage } from '@/areas/purchase-orders/PurchaseOrders/PurchaseOrdersPage/PurchaseOrdersPage';
import { canViewPurchaseOrders, canViewPurchaseOrdersModule } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/purchase-orders')({
    staticData: {
        access: { permissions: canViewPurchaseOrders, modulePermissions: canViewPurchaseOrdersModule },
        chrome: 'home',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <PurchaseOrdersPage />;
}
